import React from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';
import { useIntl } from '../../util/reactIntl';
import { richText } from '../../util/richText';

import css from './CustomExtendedDataSection.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionText = props => {
  const {
    text,
    heading,
    fieldKey,
    headingClassName,
    className,
    rootClassName,
    showAsIngress = false,
  } = props;

  const intl = useIntl();

  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  // Try a translation key derived from the field key, fall back to raw label from Sharetribe Console.
  const translationKey = fieldKey ? `listingField.${fieldKey}.label` : null;
  if (process.env.NODE_ENV === 'development' && fieldKey) {
    console.log(`[i18n] Add translation key: "listingField.${fieldKey}.label": "${heading}"`);
  }
  const translatedHeading = translationKey
    ? intl.formatMessage({ id: translationKey, defaultMessage: heading })
    : heading;

  const classes = classNames(rootClassName || css.sectionText, className);

  return text ? (
    <section className={classes}>
      {translatedHeading ? (
        <Heading as="h2" rootClassName={css.sectionHeading} className={headingClassName}>
          {translatedHeading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionText;
